/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import avatar from "../../assets/images/avatar.jpg";
import GoogleAd from "../Adsense/GoogleAd";
import severUrl from "../../api";

class RightPanel extends React.Component {
  state = {
    post: [],
    loaded: false
  };

  componentDidMount() {
    fetch(severUrl + `blog/list/relevent/`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ loaded: true })
        this.setState({ post: data });
      })
      .catch(
        (error) => {
          console.log(error)
          // setApiError(true)
        }
      );
  }
  render() {
    if (!this.state.loaded) {
      return (
      
<>
        <div
          style={{
            gridArea: "RightPanel",
            gridColumn: "30/36",
            // alignContent: "center",
            textAlign: "justify",
            marginLeft: "10px",
            marginTop: "40px",

          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateRows: "auto auto",
              padding: 0,
              margin: 0,
              textAlign: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto auto",
                padding: 0,
                margin: 0,
                width: "100%",
              }}
            ></div>
            <div
              style={{ fontSize: "14px", width: "100%", textAlign: "justify" }}
            >
              <div
                style={{
                  fontSize: "16px",
                  width: "100%",
                  textAlign: "justify",
                  marginBottom: "10px",
                  marginTop: "10px",
                }}
              >
                {" "}
                I'm <b>LOC HO </b>. <br />
                <p style={{ fontWeight: "280", fontSize: "14px", textAlign: "left" }}>I'm Researcher/Engineer. <br></br> I'm
                  interested about Embedded/AI sytem.<br></br> Hope this site is useful for
                  you.</p>
              </div>
              <a className="a_title"
                style={{ fontSize: "14px", textAlign: "justify" }}
                href="/about"
              >
                About me
              </a>
            </div>
          </div>
          <a className="a_title">ID: htanloc994@gmail.com</a>
          <h4>Courses</h4>
          <span class="brmedium"></span>
          <a className="a_title" href="https://www.cs.toronto.edu/~hinton/">Machine Learning</a>

          <span class="brmedium"></span>
          <a className="a_title" href="https://ocw.mit.edu/courses/6-079-introduction-to-convex-optimization-fall-2009/pages/lecture-notes/">
            Introduction To Convex Optimization
          </a>
          <span class="brmedium"></span>
          <a className="a_title" href="https://www.stat.cmu.edu/~ryantibs/convexopt-F18/">
            Convex Optimization
          </a>
          <span class="brmedium"></span>

          <a className="a_title" href="https://cs.brown.edu/courses/csci2950-p/lectures.html">
            Probabilistic Graphical Models
          </a>
          <span class="brmedium"></span>
          <h4>Books</h4>
          <a className="a_title" href="https://www.microsoft.com/en-us/research/uploads/prod/2006/01/Bishop-Pattern-Recognition-and-Machine-Learning-2006.pdf">
            Pattern Recognition and Machine Learning
          </a>
          <span class="brmedium"></span>
          <a className="a_title" href="https://shuyuej.com/books/Lectures%20on%20Convex%20Optimization.pdf">
            Lectures on Convex Optimization
          </a>
          <span class="brmedium"></span>
          <h4>Relevent</h4>
          <span class="brmedium"></span>
        </div>
      </>

    )
    }
    return (
      <>
        <div
          style={{
            gridArea: "RightPanel",
            gridColumn: "30/36",
            // alignContent: "center",
            textAlign: "justify",
            marginLeft: "10px",
            marginTop: "40px",

          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateRows: "auto auto",
              padding: 0,
              margin: 0,
              textAlign: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto auto",
                padding: 0,
                margin: 0,
                width: "100%",
              }}
            ></div>
            <div
              style={{ fontSize: "14px", width: "100%", textAlign: "justify" }}
            >
              <div
                style={{
                  fontSize: "16px",
                  width: "100%",
                  textAlign: "justify",
                  marginBottom: "10px",
                  marginTop: "10px",
                }}
              >
                {" "}
                I'm <b>LOC HO </b>. <br />
                <p style={{ fontWeight: "280", fontSize: "14px", textAlign: "left" }}>I'm Researcher/Engineer. <br></br> I'm
                  interested about Embedded/AI sytem.<br></br> Hope this site is useful for
                  you.</p>
              </div>
              <a className="a_title"
                style={{ fontSize: "14px", textAlign: "justify" }}
                href="/about"
              >
                About me
              </a>
            </div>
          </div>
          <a className="a_title">ID: htanloc994@gmail.com</a>
          <h4>Courses</h4>
          <span class="brmedium"></span>
          <a className="a_title" href="https://www.cs.toronto.edu/~hinton/">Machine Learning</a>

          <span class="brmedium"></span>
          <a className="a_title" href="https://ocw.mit.edu/courses/6-079-introduction-to-convex-optimization-fall-2009/pages/lecture-notes/">
            Introduction To Convex Optimization
          </a>
          <span class="brmedium"></span>
          <a className="a_title" href="https://www.stat.cmu.edu/~ryantibs/convexopt-F18/">
            Convex Optimization
          </a>
          <span class="brmedium"></span>

          <a className="a_title" href="https://cs.brown.edu/courses/csci2950-p/lectures.html">
            Probabilistic Graphical Models
          </a>
          <span class="brmedium"></span>
          <h4>Books</h4>
          <a className="a_title" href="https://www.microsoft.com/en-us/research/uploads/prod/2006/01/Bishop-Pattern-Recognition-and-Machine-Learning-2006.pdf">
            Pattern Recognition and Machine Learning
          </a>
          <span class="brmedium"></span>
          <a className="a_title" href="https://shuyuej.com/books/Lectures%20on%20Convex%20Optimization.pdf">
            Lectures on Convex Optimization
          </a>
          <span class="brmedium"></span>
          <h4>Relevent</h4>
          <span class="brmedium"></span>
          {Array.from(this.state.post).map((p) => (
            <>
              <a className="a_title" style={{ color: "#052e9d !important" }} href={"/" + p.slug}>{p.title}</a>
              <span class="brmedium"></span>
            </>
          ))}
          <GoogleAd
            classNames="GoogAd"
            slot="7756045717"
            googleAdId="ca-pub-3156532081104759"
          />
        </div>
      </>
    );
  }
}

export default RightPanel;
